import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import "core-js/modules/web.dom-collections.iterator.js";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import ImageryLayerFeatureInfo from "terriajs-cesium/Source/Scene/ImageryLayerFeatureInfo";
import WebMapServiceImageryProvider from "terriajs-cesium/Source/Scene/WebMapServiceImageryProvider";
import MappableMixin from "../../lib/ModelMixins/MappableMixin";
import TimeFilterMixin from "../../lib/ModelMixins/TimeFilterMixin";
import CommonStrata from "../../lib/Models/Definition/CommonStrata";
import CreateModel from "../../lib/Models/Definition/CreateModel";
import Terria from "../../lib/Models/Terria";
import mixTraits from "../../lib/Traits/mixTraits";
import TimeFilterTraits from "../../lib/Traits/TraitsClasses/TimeFilterTraits";
describe("TimeFilterMixin", function () {
  let terria;
  beforeEach(function () {
    terria = new Terria();
  });
  describe("canFilterTimeByFeature", function () {
    it("returns false if timeFilterPropertyName is not set", action(function () {
      const testItem = new TestTimeFilterableItem("test", terria);
      expect(testItem.canFilterTimeByFeature).toBe(false);
    }));
    it("returns true if timeFilterPropertyName is set", action(function () {
      const testItem = new TestTimeFilterableItem("test", terria);
      testItem.setTrait(CommonStrata.user, "timeFilterPropertyName", "filter-dates");
      expect(testItem.canFilterTimeByFeature).toBe(true);
    }));
  });
  describe("setTimeFilterFromLocation", function () {
    let item;
    let imageryProvider;
    beforeEach(function () {
      item = new TestTimeFilterableItem("test", terria);
      item.setTrait(CommonStrata.user, "timeFilterPropertyName", "availabilityAtLocation");
      imageryProvider = new WebMapServiceImageryProvider({
        url: "test",
        layers: "testlayer"
      });
      item.imageryProviders = [imageryProvider];
      const fullAvailability = ["2023-01-01", "2023-01-02", "2023-01-03", "2023-01-04", "2023-01-05"];
      item.discreteTimes = fullAvailability.map(time => ({
        time,
        tag: undefined
      }));
    });
    it("loads the filter with dates available for the given location and updates the timeFilterCoordinates traits", action(async function () {
      var _runInAction;
      // Set filter property to provide 2 dates from the available set
      const fakeImageryFeature = new ImageryLayerFeatureInfo();
      fakeImageryFeature.properties = {
        availabilityAtLocation: ["2023-01-02", "2023-01-03"]
      };
      spyOn(imageryProvider, "pickFeatures").and.callFake(() => Promise.resolve([fakeImageryFeature]));
      await item.setTimeFilterFromLocation({
        // Position to pick
        position: {
          // in degrees
          latitude: -37.831,
          longitude: 144.973
        },
        // Coordinates of the tiles
        tileCoords: {
          x: 1,
          y: 2,
          level: 3
        }
      });
      expect((_runInAction = runInAction(() => item.discreteTimesAsSortedJulianDates)) === null || _runInAction === void 0 ? void 0 : _runInAction.map(dt => dt.time.toString())).toEqual(["2023-01-02T00:00:00Z", "2023-01-03T00:00:00Z"]);
    }));
    it("should correctly update the timeFilterCoordinates", async function () {
      // Set filter property to provide 2 dates from the available set
      const fakeImageryFeature = new ImageryLayerFeatureInfo();
      fakeImageryFeature.properties = {
        availabilityAtLocation: ["2023-01-02", "2023-01-03"]
      };
      spyOn(imageryProvider, "pickFeatures").and.callFake(() => Promise.resolve([fakeImageryFeature]));
      await item.setTimeFilterFromLocation({
        // Position to pick
        position: {
          // in degrees
          latitude: -37.831,
          longitude: 144.973
        },
        // Coordinates of the tiles
        tileCoords: {
          x: 1,
          y: 2,
          level: 3
        }
      });
      const {
        tile: {
          x,
          y,
          level
        },
        latitude,
        longitude,
        height
      } = runInAction(() => item.timeFilterCoordinates);
      expect({
        x,
        y,
        level
      }).toEqual({
        x: 1,
        y: 2,
        level: 3
      });
      expect({
        latitude,
        longitude,
        height
      }).toEqual({
        longitude: 144.973,
        latitude: -37.831,
        height: 0
      });
    });
    describe("when there are multiple imageryProviders", function () {
      it("queries all of them", async function () {
        item.imageryProviders = [new WebMapServiceImageryProvider({
          url: "test1",
          layers: "layer1"
        }), new WebMapServiceImageryProvider({
          url: "test2",
          layers: "layer2"
        })];
        const spy0 = spyOn(item.imageryProviders[0], "pickFeatures").and.returnValue(undefined);
        const spy1 = spyOn(item.imageryProviders[1], "pickFeatures").and.returnValue(undefined);
        await item.setTimeFilterFromLocation({
          // Position to pick
          position: {
            // in degrees
            latitude: -37.831,
            longitude: 144.973
          },
          // Coordinates of the tiles
          tileCoords: {
            x: 1,
            y: 2,
            level: 3
          }
        });
        expect(spy0).toHaveBeenCalledTimes(1);
        expect(spy1).toHaveBeenCalledTimes(1);
      });
      it("sets the time filter from the first imageryProvider that returns a valid pick result", action(async function () {
        var _item$discreteTimesAs;
        item.imageryProviders = [new WebMapServiceImageryProvider({
          url: "test1",
          layers: "layer1"
        }), new WebMapServiceImageryProvider({
          url: "test2",
          layers: "layer2"
        })];
        const featureInfo1 = new ImageryLayerFeatureInfo();
        featureInfo1.properties = {
          someprop: ["2023-01-01"]
        };
        const featureInfo2 = new ImageryLayerFeatureInfo();
        featureInfo2.properties = {
          timeprop: ["2023-01-04"]
        };
        item.setTrait(CommonStrata.user, "timeFilterPropertyName", "timeprop");
        const spy0 = spyOn(item.imageryProviders[0], "pickFeatures").and.callFake(() => Promise.resolve([featureInfo1]));
        const spy1 = spyOn(item.imageryProviders[1], "pickFeatures").and.callFake(() => Promise.resolve([featureInfo2]));
        await item.setTimeFilterFromLocation({
          // Position to pick
          position: {
            // in degrees
            latitude: -37.831,
            longitude: 144.973
          },
          // Coordinates of the tiles
          tileCoords: {
            x: 1,
            y: 2,
            level: 3
          }
        });
        expect(spy0).toHaveBeenCalledTimes(1);
        expect(spy1).toHaveBeenCalledTimes(1);
        expect(((_item$discreteTimesAs = item.discreteTimesAsSortedJulianDates) !== null && _item$discreteTimesAs !== void 0 ? _item$discreteTimesAs : []).map(dt => dt.time.toString())).toEqual(["2023-01-04T00:00:00Z"]);
      }));
    });
    it("passes the correct arguments when picking the imagery provider", async function () {
      const spy = spyOn(imageryProvider, "pickFeatures").and.returnValue(undefined);
      await item.setTimeFilterFromLocation({
        // Position to pick
        position: {
          // in degrees
          latitude: -37.831,
          longitude: 144.973
        },
        // Coordinates of the tiles
        tileCoords: {
          x: 1,
          y: 2,
          level: 3
        }
      });
      const [x, y, level, longitude, latitude] = spy.calls.mostRecent().args;
      expect([x, y, level]).toEqual([1, 2, 3]);
      expect(longitude).toBeCloseTo(2.5302);
      expect(latitude).toBeCloseTo(-0.6602);
    });
    it("does nothing when terria.allowFeatureInfoRequests is set to `false`", async function () {
      const pickFeatures = spyOn(imageryProvider, "pickFeatures").and.returnValue(undefined);
      terria.allowFeatureInfoRequests = false;
      await item.setTimeFilterFromLocation({
        // Position to pick
        position: {
          // in degrees
          latitude: -37.831,
          longitude: 144.973
        },
        // Coordinates of the tiles
        tileCoords: {
          x: 1,
          y: 2,
          level: 3
        }
      });
      expect(pickFeatures).not.toHaveBeenCalled();
    });
  });
});
let TestTimeFilterableItem = (_class = class TestTimeFilterableItem extends TimeFilterMixin(MappableMixin(CreateModel(mixTraits(TimeFilterTraits)))) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "discreteTimes", _descriptor, this);
    _initializerDefineProperty(this, "imageryProviders", _descriptor2, this);
    makeObservable(this);
  }
  async forceLoadMapItems() {}
  get mapItems() {
    return this.imageryProviders.map(imageryProvider => ({
      imageryProvider,
      alpha: 1.0,
      show: true,
      clippingRectangle: imageryProvider.rectangle
    }));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "discreteTimes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "imageryProviders", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _class);